import { useState } from 'react';
import Carousel from 'components/carousel';
import { useAppContext } from 'use-app';
import styles from './index.module.sass';
import amplitude from 'service/amplitude';
import { openLink } from 'helpers/link-helper';
import { getLoginState } from 'model/user';
import videoExtlists from 'video-extensions';
import Dialog from 'components/dialog';

const Promotion = ({ promotion, openDialog, setDialogContent }) => {
  const { imageUrl } = promotion.attributes;

  if (promotion.action.messageBox) {
    return (
      <div
        className={styles.promotion}
        style={{ backgroundImage: `url(${imageUrl})` }}
        onClick={() => {
          openDialog();
          setDialogContent(promotion.action.messageBox);
          amplitude.main_ads_onClick(promotion.id);
          amplitude.ads_onClick(promotion.id);
        }}
      >
        aefawefawefawefew
      </div>
    );
  } else {
    const { uri } = promotion.action.openLink;
    const imageUrlArr = imageUrl.split('.');
    const imageExt = imageUrlArr[imageUrlArr.length - 1];

    if (videoExtlists.indexOf(imageExt) !== -1) {
      return (
        <div
          className={styles.promotion}
          onClick={() => {
            if (uri) openLink(uri);
            amplitude.main_ads_onClick(promotion.id);
            amplitude.ads_onClick(promotion.id);
          }}
        >
          <video autoPlay loop playsInline muted style={{ position: 'absolute', top: 0, left: 0, width: '100%' }}>
            <source src={imageUrl} type={`video/${imageExt}`} />
          </video>
        </div>
      );
    }

    return (
      <div
        className={styles.promotion}
        style={{ backgroundImage: `url(${imageUrl})` }}
        onClick={() => {
          if (uri) openLink(uri);
          amplitude.main_ads_onClick(promotion.id);
          amplitude.ads_onClick(promotion.id);
        }}
      />
    );
  }
};

const Promotions = () => {
  const { state: appState } = useAppContext();
  let promotions = appState.mainPagePromotionBoard;
  const loginState = getLoginState();
  const isUser = loginState === 'user';
  promotions = isUser ? promotions : promotions.filter(p => !p.action.needLogin);
  const [dialogShow, setDialogShow] = useState(false);
  const [dialogContent, setDialogContent] = useState({});

  if (!promotions || promotions.length === 0) return <></>;

  return (
    <>
      <Dialog
        isShow={dialogShow}
        image={dialogContent.image}
        title={dialogContent.title}
        message={dialogContent.message}
        button={dialogContent.positiveButton}
        onConfirm={() => setDialogShow(false)}
        onDismiss={() => setDialogShow(false)}
      />
      <div className={styles.promotions}>
        <Carousel
          indicatorInsideCard={true}
          loading={false}
          items={promotions?.slice(0, 10).map(promotion => {
            return (
              <Promotion
                promotion={promotion}
                key={promotion.id}
                openDialog={() => setDialogShow(true)}
                setDialogContent={setDialogContent}
              />
            );
          })}
        />
      </div>
    </>
  );
};

export default Promotions;
